// 数字递增的动画
const figureObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                figureStepAdd(target)
                // 可见区域后 下次不在执行监听
                figureObserver.unobserve(target)
            }
        })
    },
    {
        // 默认值为null，也就是视口区域,表示监听的可视区域为整个视口，也就是浏览器的可视区域
        root: null,
        // 属性决定了什么时候触发回调函数。默认为[0] 比如，[0, 0.25, 0.5, 0.75, 1]就表示当目标元素 0%、25%、50%、75%、100% 可见时，会触发回调函数。
        threshold: [1],
        // 定义根元素的margin,用来扩展可视区的范围,或者可以这样理解，root元素，多了一个margin属性，如果没有这个margin属性，
        // ele元素只有与root元素开始交叉时才会触发可视性的变化，而这个rootMargin属性的话，就是当ele元素与root元素的外边距交叉时，就会触发ele元素的可视性变化。
        rootMargin: '0px'
    }
)

let eles = document.querySelectorAll('.figure-step-add')
for(let ele of eles){
    figureObserver.observe(ele)
}

const figureStepAdd = ele => {
    let figure = ele.getAttribute('figure') || 0;
    if(parseInt(figure) === parseFloat(figure)) {
        // 整数
        let startVal = 0
        ele.innerHTML = 0;
        let interval1 = setInterval(() => {
            if(startVal + 10 < figure) {
                startVal = startVal + 10
                ele.innerHTML = startVal
            } else {
                clearInterval(interval1)
                let interval2 = setInterval(() => {
                    if(startVal + 1 <= figure) {
                        startVal = startVal + 1
                        ele.innerHTML = startVal
                    } else {
                        clearInterval(interval2)
                    }
                }, 150)
            }
        },80)
    } else {
        // 小数
        let startVal = 0.0
        ele.innerHTML = 0.0;
        let interval1 = setInterval(() => {
            if(startVal + 0.5 < figure) {
                startVal = startVal + 0.5
                ele.innerHTML = startVal.toFixed(1)
            } else {
                clearInterval(interval1)
                let interval2 = setInterval(() => {
                    if(startVal + 0.1 <= figure) {
                        startVal = startVal + 0.1
                        startVal = Number(startVal.toFixed(1))
                        ele.innerHTML = startVal
                    } else {
                        clearInterval(interval2)
                    }
                }, 150)
            }
        },80)
    }
}


// 头像的动画
const personObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                personAreaAnimation(target)
                // 可见区域后 下次不在执行监听
                personObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)
let personArea = document.querySelector('.article-first .person-area')
personObserver.observe(personArea)

const personAreaAnimation = ele => {
    let svgs = ele.querySelectorAll('.person')
    for (let i = 0; i < svgs.length; i++) {
        setTimeout(() => {
            svgs[i].style.opacity = '1'
        }, 300 * i)
    }
}



// 折线图动画
const chartObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                chartAnimation(target)
                // 可见区域后 下次不在执行监听
                chartObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [0.8],
        rootMargin: '0px'
    }
)
let element = document.querySelector('.article-second-section .chart-area')
chartObserver.observe(element)

const chartAnimation = ele => {
    let bottom = ele.querySelector('.chart-bottom'),
        top = ele.querySelector('.chart-top'),
        card = ele.querySelector('.text-area')
    bottom.style.opacity = '1'
    setTimeout(() => {
        top.style.opacity = '1'
    }, 1000)
    setTimeout(() => {
        card.style.opacity = '1'
    }, 2000)
}


// 横向柱状图动画
const barWidthObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                target.style.animation = 'barIncreaseWidth 2s ease'
                barWidthObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)


let barWidthList = document.querySelectorAll('.chart-item-bar-width')
for(let bar of barWidthList){
    barWidthObserver.observe(bar)
}



// 圆环的动画
const sectorObserver = new IntersectionObserver(
    (entries) => {
        entries.forEach(IntersectionObserverEntry => {
            let { isIntersecting, target } = IntersectionObserverEntry
            if (isIntersecting) {
                sectorAnimation(target)
                sectorObserver.unobserve(target)
            }
        })
    },
    {
        root: null,
        threshold: [1],
        rootMargin: '0px'
    }
)

const sector = document.getElementById('sector-chart');
sectorObserver.observe(sector)

const sectorAnimation = ele => {
    let figure = parseInt(ele.getAttribute('figure')) || 0,
        startVal = 0;
    ele.style.background = 'conic-gradient(#ffffff 0deg, #ffffff 0%, #ffffff 0%, #ffffff 100%)';
    let interval = setInterval(() => {
        if(startVal + 5 <= figure) {
            startVal = startVal + 5
            ele.style.background = `conic-gradient(#f6695d 0, #fef2f2 ${startVal}%, #ffffff ${Number(startVal) + .5}%, #ffffff 100%)`;
        } else {
            startVal = startVal + 5
            if (startVal >= 100) {
                ele.style.background = `conic-gradient(#f6695d 0, #fef2f2 ${figure}%, #ffe478 ${Number(figure) + .5}%, #fed2aa 100%`;
                clearInterval(interval)
            } else {
                ele.style.background = `conic-gradient(#f6695d 0, #fef2f2 ${figure}%, #ffe478 ${Number(figure) + .5}%, #fed2aa ${startVal}%, #ffffff ${Number(startVal) + .5}%, #ffffff 100%)`;
            }
        }
    },50)
}

